exports.getOptionValue = (option) => {

    if (option && typeof option === 'object') {
        return option.value ?? option.id ?? option.year ?? option.name ?? '';
    }

    return option;
};

exports.getOptionLabel = (option) => {

    if (option && typeof option === 'object') {
        return option.label ?? option.name ?? option.year ?? option.value ?? option.id ?? '';
    }

    return option;
};
